/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "./API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const onAdminReceiveChatMessageFromVenueOrUser = /* GraphQL */ `subscription OnAdminReceiveChatMessageFromVenueOrUser {
  onAdminReceiveChatMessageFromVenueOrUser {
    fromUserId
    toUserId
    conversationId
    userType
    messageTime
    message
    messageType
    received
    seen
    rejected
    url
    title
    thumbnail
    complaintID
    agencyName
    agencyImages {
      thumbnail
      small
      medium
      large
      video
      __typename
    }
    agencyThumbnail
    edited
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnAdminReceiveChatMessageFromVenueOrUserSubscriptionVariables,
  APITypes.OnAdminReceiveChatMessageFromVenueOrUserSubscription
>;
export const onVenueReceiveChatMessageFromAdmin = /* GraphQL */ `subscription OnVenueReceiveChatMessageFromAdmin(
  $userType: String!
  $toUserId: String!
) {
  onVenueReceiveChatMessageFromAdmin(userType: $userType, toUserId: $toUserId) {
    fromUserId
    toUserId
    conversationId
    userType
    messageTime
    message
    messageType
    received
    seen
    rejected
    url
    title
    thumbnail
    complaintID
    agencyName
    agencyImages {
      thumbnail
      small
      medium
      large
      video
      __typename
    }
    agencyThumbnail
    edited
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnVenueReceiveChatMessageFromAdminSubscriptionVariables,
  APITypes.OnVenueReceiveChatMessageFromAdminSubscription
>;
export const onUserReceiveChatMessageFromAdmin = /* GraphQL */ `subscription OnUserReceiveChatMessageFromAdmin(
  $userType: String!
  $toUserId: String!
) {
  onUserReceiveChatMessageFromAdmin(userType: $userType, toUserId: $toUserId) {
    fromUserId
    toUserId
    conversationId
    userType
    messageTime
    message
    messageType
    received
    seen
    rejected
    url
    title
    thumbnail
    complaintID
    agencyName
    agencyImages {
      thumbnail
      small
      medium
      large
      video
      __typename
    }
    agencyThumbnail
    edited
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUserReceiveChatMessageFromAdminSubscriptionVariables,
  APITypes.OnUserReceiveChatMessageFromAdminSubscription
>;
export const onVenueReceiveChatMessageFromUser = /* GraphQL */ `subscription OnVenueReceiveChatMessageFromUser(
  $userType: String!
  $toUserId: String!
  $fromUserId: String!
) {
  onVenueReceiveChatMessageFromUser(
    userType: $userType
    toUserId: $toUserId
    fromUserId: $fromUserId
  ) {
    fromUserId
    toUserId
    conversationId
    userType
    messageTime
    message
    messageType
    received
    seen
    rejected
    url
    title
    thumbnail
    complaintID
    agencyName
    agencyImages {
      thumbnail
      small
      medium
      large
      video
      __typename
    }
    agencyThumbnail
    edited
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnVenueReceiveChatMessageFromUserSubscriptionVariables,
  APITypes.OnVenueReceiveChatMessageFromUserSubscription
>;
export const onAgencyReceiveChatMessageFromUser = /* GraphQL */ `subscription OnAgencyReceiveChatMessageFromUser(
  $userType: String!
  $toUserId: String!
  $fromUserId: String!
) {
  onAgencyReceiveChatMessageFromUser(
    userType: $userType
    toUserId: $toUserId
    fromUserId: $fromUserId
  ) {
    fromUserId
    toUserId
    conversationId
    userType
    messageTime
    message
    messageType
    received
    seen
    rejected
    url
    title
    thumbnail
    complaintID
    agencyName
    agencyImages {
      thumbnail
      small
      medium
      large
      video
      __typename
    }
    agencyThumbnail
    edited
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnAgencyReceiveChatMessageFromUserSubscriptionVariables,
  APITypes.OnAgencyReceiveChatMessageFromUserSubscription
>;
export const onUserReceiveChatMessageFromVenue = /* GraphQL */ `subscription OnUserReceiveChatMessageFromVenue(
  $userType: String!
  $toUserId: String!
  $fromUserId: String!
) {
  onUserReceiveChatMessageFromVenue(
    userType: $userType
    toUserId: $toUserId
    fromUserId: $fromUserId
  ) {
    fromUserId
    toUserId
    conversationId
    userType
    messageTime
    message
    messageType
    received
    seen
    rejected
    url
    title
    thumbnail
    complaintID
    agencyName
    agencyImages {
      thumbnail
      small
      medium
      large
      video
      __typename
    }
    agencyThumbnail
    edited
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUserReceiveChatMessageFromVenueSubscriptionVariables,
  APITypes.OnUserReceiveChatMessageFromVenueSubscription
>;
export const onMessagingBtwVenueAndUser = /* GraphQL */ `subscription OnMessagingBtwVenueAndUser(
  $userType: String!
  $toUserId: String!
) {
  onMessagingBtwVenueAndUser(userType: $userType, toUserId: $toUserId) {
    fromUserId
    toUserId
    conversationId
    userType
    messageTime
    message
    messageType
    received
    seen
    rejected
    url
    title
    thumbnail
    complaintID
    agencyName
    agencyImages {
      thumbnail
      small
      medium
      large
      video
      __typename
    }
    agencyThumbnail
    edited
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnMessagingBtwVenueAndUserSubscriptionVariables,
  APITypes.OnMessagingBtwVenueAndUserSubscription
>;
export const onUserReceiveChatMessageFromAgency = /* GraphQL */ `subscription OnUserReceiveChatMessageFromAgency(
  $userType: String!
  $toUserId: String!
  $fromUserId: String!
) {
  onUserReceiveChatMessageFromAgency(
    userType: $userType
    toUserId: $toUserId
    fromUserId: $fromUserId
  ) {
    fromUserId
    toUserId
    conversationId
    userType
    messageTime
    message
    messageType
    received
    seen
    rejected
    url
    title
    thumbnail
    complaintID
    agencyName
    agencyImages {
      thumbnail
      small
      medium
      large
      video
      __typename
    }
    agencyThumbnail
    edited
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnUserReceiveChatMessageFromAgencySubscriptionVariables,
  APITypes.OnUserReceiveChatMessageFromAgencySubscription
>;
export const onMessagingBtwAgencyAndUser = /* GraphQL */ `subscription OnMessagingBtwAgencyAndUser(
  $userType: String!
  $toUserId: String!
) {
  onMessagingBtwAgencyAndUser(userType: $userType, toUserId: $toUserId) {
    fromUserId
    toUserId
    conversationId
    userType
    messageTime
    message
    messageType
    received
    seen
    rejected
    url
    title
    thumbnail
    complaintID
    agencyName
    agencyImages {
      thumbnail
      small
      medium
      large
      video
      __typename
    }
    agencyThumbnail
    edited
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnMessagingBtwAgencyAndUserSubscriptionVariables,
  APITypes.OnMessagingBtwAgencyAndUserSubscription
>;
export const onAdminReceiveChatMessageFromAdmin = /* GraphQL */ `subscription OnAdminReceiveChatMessageFromAdmin($conversationId: String!) {
  onAdminReceiveChatMessageFromAdmin(conversationId: $conversationId) {
    fromUserId
    toUserId
    conversationId
    userType
    messageTime
    message
    messageType
    received
    seen
    rejected
    url
    title
    thumbnail
    complaintID
    agencyName
    agencyImages {
      thumbnail
      small
      medium
      large
      video
      __typename
    }
    agencyThumbnail
    edited
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnAdminReceiveChatMessageFromAdminSubscriptionVariables,
  APITypes.OnAdminReceiveChatMessageFromAdminSubscription
>;
export const onMessageUpdated = /* GraphQL */ `subscription OnMessageUpdated($conversationId: String!) {
  onMessageUpdated(conversationId: $conversationId) {
    fromUserId
    toUserId
    conversationId
    userType
    messageTime
    message
    messageType
    received
    seen
    rejected
    url
    title
    thumbnail
    complaintID
    agencyName
    agencyImages {
      thumbnail
      small
      medium
      large
      video
      __typename
    }
    agencyThumbnail
    edited
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnMessageUpdatedSubscriptionVariables,
  APITypes.OnMessageUpdatedSubscription
>;
export const onMessageRejected = /* GraphQL */ `subscription OnMessageRejected(
  $conversationId: String!
  $messageTime: String!
) {
  onMessageRejected(
    conversationId: $conversationId
    messageTime: $messageTime
  ) {
    fromUserId
    toUserId
    conversationId
    userType
    messageTime
    message
    messageType
    received
    seen
    rejected
    url
    title
    thumbnail
    complaintID
    agencyName
    agencyImages {
      thumbnail
      small
      medium
      large
      video
      __typename
    }
    agencyThumbnail
    edited
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnMessageRejectedSubscriptionVariables,
  APITypes.OnMessageRejectedSubscription
>;
export const onChatClosed = /* GraphQL */ `subscription OnChatClosed($userType: String!, $toUserId: String!) {
  onChatClosed(userType: $userType, toUserId: $toUserId) {
    fromUserId
    toUserId
    conversationId
    userType
    messageTime
    message
    messageType
    received
    seen
    rejected
    url
    title
    thumbnail
    complaintID
    agencyName
    agencyImages {
      thumbnail
      small
      medium
      large
      video
      __typename
    }
    agencyThumbnail
    edited
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnChatClosedSubscriptionVariables,
  APITypes.OnChatClosedSubscription
>;
export const onAdminUpdateChatMessage = /* GraphQL */ `subscription OnAdminUpdateChatMessage(
  $messageTime: String!
  $conversationId: String!
) {
  onAdminUpdateChatMessage(
    messageTime: $messageTime
    conversationId: $conversationId
  ) {
    fromUserId
    toUserId
    conversationId
    userType
    messageTime
    message
    messageType
    received
    seen
    rejected
    url
    title
    thumbnail
    complaintID
    agencyName
    agencyImages {
      thumbnail
      small
      medium
      large
      video
      __typename
    }
    agencyThumbnail
    edited
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnAdminUpdateChatMessageSubscriptionVariables,
  APITypes.OnAdminUpdateChatMessageSubscription
>;
export const onVenueUpdateChatMessage = /* GraphQL */ `subscription OnVenueUpdateChatMessage(
  $messageTime: String!
  $conversationId: String!
) {
  onVenueUpdateChatMessage(
    messageTime: $messageTime
    conversationId: $conversationId
  ) {
    fromUserId
    toUserId
    conversationId
    userType
    messageTime
    message
    messageType
    received
    seen
    rejected
    url
    title
    thumbnail
    complaintID
    agencyName
    agencyImages {
      thumbnail
      small
      medium
      large
      video
      __typename
    }
    agencyThumbnail
    edited
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnVenueUpdateChatMessageSubscriptionVariables,
  APITypes.OnVenueUpdateChatMessageSubscription
>;
export const onAgencyUpdateChatMessage = /* GraphQL */ `subscription OnAgencyUpdateChatMessage(
  $messageTime: String!
  $conversationId: String!
) {
  onAgencyUpdateChatMessage(
    messageTime: $messageTime
    conversationId: $conversationId
  ) {
    fromUserId
    toUserId
    conversationId
    userType
    messageTime
    message
    messageType
    received
    seen
    rejected
    url
    title
    thumbnail
    complaintID
    agencyName
    agencyImages {
      thumbnail
      small
      medium
      large
      video
      __typename
    }
    agencyThumbnail
    edited
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnAgencyUpdateChatMessageSubscriptionVariables,
  APITypes.OnAgencyUpdateChatMessageSubscription
>;
export const onAdminDeleteChatMessage = /* GraphQL */ `subscription OnAdminDeleteChatMessage(
  $messageTime: String!
  $conversationId: String!
) {
  onAdminDeleteChatMessage(
    messageTime: $messageTime
    conversationId: $conversationId
  ) {
    conversationId
    messageTime
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnAdminDeleteChatMessageSubscriptionVariables,
  APITypes.OnAdminDeleteChatMessageSubscription
>;
export const onVenueDeleteChatMessage = /* GraphQL */ `subscription OnVenueDeleteChatMessage(
  $messageTime: String!
  $conversationId: String!
) {
  onVenueDeleteChatMessage(
    messageTime: $messageTime
    conversationId: $conversationId
  ) {
    conversationId
    messageTime
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnVenueDeleteChatMessageSubscriptionVariables,
  APITypes.OnVenueDeleteChatMessageSubscription
>;
export const onAgencyDeleteChatMessage = /* GraphQL */ `subscription OnAgencyDeleteChatMessage(
  $messageTime: String!
  $conversationId: String!
) {
  onAgencyDeleteChatMessage(
    messageTime: $messageTime
    conversationId: $conversationId
  ) {
    conversationId
    messageTime
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnAgencyDeleteChatMessageSubscriptionVariables,
  APITypes.OnAgencyDeleteChatMessageSubscription
>;
export const onSystemUserIntelResponse = /* GraphQL */ `subscription OnSystemUserIntelResponse($queryID: String!) {
  onSystemUserIntelResponse(queryID: $queryID) {
    queryID
    userID
    result
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.OnSystemUserIntelResponseSubscriptionVariables,
  APITypes.OnSystemUserIntelResponseSubscription
>;
